import { Injectable, inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { RegistryService } from '@fairandsmart/angular';
import { Registry } from '@fairandsmart/types';
import { Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class RegistryResolver implements Resolve<Registry> {
  private readonly registryService = inject(RegistryService);

  private readonly translateService = inject(TranslateService);

  resolve(): Observable<Registry> {
    if (!this.registryService.getRegistry()) {
      return this.registryService.loadRegistry(this.translateService.currentLang);
    }
    return of(this.registryService.getRegistry());
  }
}
